@if (this.ups.preferences(); as prefs) {
  <div class="content" [ngStyle]="{'max-width': '740px', 'background-color': prefs.panelColor}">
    @switch (prefs.status) {
      @case ('HOLD') {
        <div>
          <h1>Temporarily Unavailable</h1>
          <p>{{prefs.universityName}}’s Net Price Calculator is temporarily unavailable. Please contact our Financial Aid Office directly for more information.</p>
        </div>
      }
      @case ('DEACTIVATED') {
        <div>
          <h1>We've moved!</h1>
          <p>{{prefs.universityName}}’s Net Price Calculator is is no longer here. Please browse through our school’s <a [href]="prefs.npcExitUrl">website</a> for the information you’re looking for.</p>
        </div>
      }
      @case ('COMING') {
        <div>
          <h1>Coming soon!</h1>
          <p>{{prefs.universityName}}’s new Net Price Calculator is coming soon. Stay tuned for more details. In the meantime, please browse through our school’s <a [href]="prefs.npcExitUrl">website</a> for the information you’re looking for.</p>
        </div>
      }
    }
    <p>You can search a list of schools that use the College Board Net Price Calculator
      <a href="https://professionals.collegeboard.org/higher-ed/financial-aid/netprice/participating-schools">here.</a>
    </p>
  </div>
} @else {
  <div class="content" [ngStyle]="{'max-width': '740px'}">
    <h1>No School Selected</h1>
    <p>There is no current school selected.</p>
    <p>This page will show status if a school is unavailable.</p>
    <p></p>
    <p>You can review a demo version of the Net Price Calculator
      <a href="https://npc.collegeboard.org/app/faber">here.</a>
    </p>
  </div>
}

